import React from 'react';
import PropTypes from 'prop-types';
import { BaseDialog, Upload03Icon } from '@metarouter-private/mr-mui';
import UploadModalContent from './UploadModalContent';
import UploadModalActions from './UploadModalActions';
import useAnalyticsFileUpload from 'app/components/analytics-builder/useAnalyticsFileUpload';

export default function AjsFileUploadModal({
  open,
  onClose,
  setField,
  addIdentitySyncs,
  setStagedIntegrations,
  formState,
  stagedIdentitySyncs,
  stagedIntegrations,
}) {
  const { selectedFile, fileInputKey, updateMode, handleFileChange, handleModeChange, handleConfirm, resetFileInput } =
    useAnalyticsFileUpload({
      setField,
      addIdentitySyncs,
      setStagedIntegrations,
      formState,
      stagedIdentitySyncs,
      stagedIntegrations,
      onSuccess: onClose,
    });

  const handleClose = () => {
    resetFileInput();
    onClose();
  };

  return (
    <BaseDialog
      DialogProps={{
        open,
        onClose: handleClose,
      }}
      title="Upload Analytics File"
      TitleIcon={Upload03Icon}
      content={
        <UploadModalContent
          fileInputKey={fileInputKey}
          selectedFile={selectedFile}
          onFileChange={handleFileChange}
          updateMode={updateMode}
          onModeChange={handleModeChange}
        />
      }
      actions={<UploadModalActions onCancel={handleClose} onConfirm={handleConfirm} disabled={!selectedFile} />}
    />
  );
}

AjsFileUploadModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  setField: PropTypes.func.isRequired,
  addIdentitySyncs: PropTypes.func.isRequired,
  setStagedIntegrations: PropTypes.func.isRequired,
  formState: PropTypes.object.isRequired,
  stagedIdentitySyncs: PropTypes.array.isRequired,
  stagedIntegrations: PropTypes.array.isRequired,
};
